import services from '@/http'
import * as types from './mutation-types'

// MODELS
export const ActionFindClass = ({
  commit
}, payload) => (
  services.showClass.findClass({
    id: payload
  }).then(res => {
    commit(types.SET_CLASS, res.data)
  })
)

export const ActionUpdateClass = (context, payload) => (
  services.showClass.updateClass(payload)
)

export const ActionDeleteClass = (context, payload) => (
  services.showClass.deleteClass({
    id: payload.id
  })
)

export const ActionSetClass = ({
  commit
}, payload) => {
  commit(types.SET_CLASS, payload)
}

export const ActionSortClass = ({
  commit
}, payload) => {
  if (!payload) return;
  //if (!payload) return;

  let clss = payload
  clss.classSchedules.sort((a, b) => {
    let compare = 0;
    if (a.timeStart > b.timeStart) {
      compare = 1;
    } else if (b.timeStart > a.timeStart) {
      compare = -1;
    }
    return compare;
  });
  payload = clss;

  commit(types.SET_CLASS, payload);
}

export const ActionSetClassSchedule = ({
  commit
}, payload) => {
  commit(types.SET_CLASS_SCHEDULE, payload)
}

export const ActionSetArrayClassSchedules = ({
  commit
}, payload) => {
  commit(types.SET_ARRAY_CLASS_SCHEDULE, payload)
}


// ITENS DE FORMULÁRIO
export const ActionShowEditClassDialog = ({
  dispatch,
  commit
}, payload) => {

  dispatch('ActionFindClass', payload)
  commit(types.SET_SHOW_CLASS_DIALOG, true)
}

export const ActionSetShowClassDialog = ({
  commit
}, payload) => {
  commit(types.SET_SHOW_CLASS_DIALOG, payload)
  if (!payload)
    commit(types.SET_SHOW_CLASS_TIME_DIALOG, payload)
}

export const ActionSetShowClassTimeDialog = ({
  commit
}, payload) => {
  commit(types.SET_SHOW_CLASS_TIME_DIALOG, payload)
}

// GERAL

export const ActionReset = ({
  commit
}) => {
  commit(types.SET_SHOW_CLASS_TIME_DIALOG, false)
  commit(types.SET_SHOW_CLASS_DIALOG, false)
  //false para habilitar a progressbar e o form
  commit(types.SET_CLASS, false)


}